import React, { useEffect } from "react";
import "./VideoPlayer.css";
import {  useParams } from "react-router-dom";

const VideoPlayer = () => {

    const {id: videoId} = useParams()
    
  useEffect(() => {
    let startTime = 0;
    let accumulatedWatchTime = 0;
    let player;

    const onPlayerStateChange = (event) => {
      switch (event.data) {
        case window.YT.PlayerState.PLAYING:
          startTime = Date.now();
          break;
        case window.YT.PlayerState.PAUSED:
        case window.YT.PlayerState.ENDED:
          if (startTime) {
            const elapsedTime = (Date.now() - startTime) / 1000; // seconds
            accumulatedWatchTime += elapsedTime;
            startTime = 0;
            if (window.Android && window.Android.onSavedWatchTime) {
              window.Android.onSavedWatchTime(accumulatedWatchTime);
            }
          }
          break;
        default:
          break;
      }
    };

    const onPlayerReady = (event) => {
      event.target.playVideo();
    };

    const loadYouTubeIframeAPI = () => {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = () => {
        player = new window.YT.Player("player", {
          height: "100%",
          width: "100%",
          videoId: videoId,
          playerVars: { autoplay: 1, controls: 1 },
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
        });
      };
    };

    loadYouTubeIframeAPI();
  }, [videoId]);

  return (
    <div className="video-container">
      <div id="player"></div>
    </div>
  );
};

export default VideoPlayer;
